const ROOT = '/challan-management'

const challanManagementPaths = {
  root: ROOT,
//   AddArea: `${ROOT}/add-area`,
};

export default challanManagementPaths;